import axios, { AxiosRequestConfig, AxiosResponse } from "axios";

export type getAllStationAQIDataResponse = {
  data: any[];
  status: string;
  message: number;
};

export const getAllStationAQIData = async (): Promise<
  AxiosResponse<getAllStationAQIDataResponse>
> => {
  const config: AxiosRequestConfig = {
    method: "get",
    url: "https://api.paribesh.wtlprojects.com/api/v1/admin/aqi/get_all_stations",
  };
  console.log("Fetching AQI data");
  const response: AxiosResponse<getAllStationAQIDataResponse> = await axios(
    config
  )
    .then((r: any) => {
      console.log("AQI data received");
      return r;
    })
    .catch((err: any) => {
      console.log("error while getting AQI data");
      return err.response;
    });

  return response;
};
